import { Empty, Flex } from "antd";
import { useNavigate } from "react-router";
import { useGetPublicCoursesQuery } from "../../../../app/features/courses/courses.api";
import CourseItem from "../../../../components/ui/CourseItem";
import CourseItemSkeleton from "../../../../components/ui/CourseItemSkeleton";
import Title from "../../../../components/ui/Title";
import useError from "../../../../hooks/useError";

export default function PopularCourse() {
  const navigate = useNavigate();
  const { isLoading, error, data } = useGetPublicCoursesQuery({
    limit: 6,
    sort: "POPULAR",
  });
  useError(error, "কোর্স লোড করতে ব্যর্থ হয়েছে");

  return (
    <section className="py-12 lg:py-24 container mini-container">
      <Flex justify="center">
        <span className="text-base lg:text-lg font-medium text-theme-primary px-5 py-2 rounded-[100px] bg-theme-primary/10 inline-block w-auto">
          বৈশিষ্ট্যযুক্ত কোর্স
        </span>
      </Flex>
      <Title className="text-center mb-2 mt-4">জনপ্রিয় কোর্সসমূহ</Title>
      <div className="text-theme-slate-700 text-base lg:text-lg font-normal max-w-xl mx-auto text-center">
        আমাদের বৈশিষ্ট্যযুক্ত কোর্সগুলি আবিষ্কার করুন, বিশেষভাবে তৈরি করা হয়েছে
        যাতে আপনি চাহিদা অনুযায়ী দক্ষতা অর্জন করতে পারেন
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
        {isLoading ? (
          Array.from({ length: 6 }).map((_, index) => (
            <CourseItemSkeleton key={index} />
          ))
        ) : (data?.items || [])?.length > 0 ? (
          data?.items?.map((course) => (
            <CourseItem
              key={course?.id}
              img={course?.thumbnailUrl}
              title={course?.title}
              category={course?.category?.name}
              description={course?.description}
              price={course?.price}
              offerPrice={course?.offerPrice}
              tags={course?.CourseTag?.map((tag) => ({
                title: tag.Tag?.name,
                icon: undefined,
              }))}
              id={course?.id}
              onMoreButton={() => navigate(`courses/${course?.id}`)}
              courseUuid={course?.uuid}
            />
          ))
        ) : (
          <div className="flex items-center justify-center md:col-span-2 lg:col-span-3">
            <Empty description="কোর্স সমূহ পাওয়া যায়নি" />
          </div>
        )}
      </div>
    </section>
  );
}
